/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
/**
 * User deactivation initiator type.
 **/
export var UserDeactivationType;
(function (UserDeactivationType) {
    UserDeactivationType["CL_ADMIN_INITIATED"] = "CL_ADMIN_INITIATED";
    UserDeactivationType["PASSPORT_ADMIN_INITIATED"] = "PASSPORT_ADMIN_INITIATED";
    UserDeactivationType["SANDFIRE_INITIATED"] = "SANDFIRE_INITIATED";
    UserDeactivationType["PNS_HARD_BOUNCE_INITIATED"] = "PNS_HARD_BOUNCE_INITIATED";
})(UserDeactivationType || (UserDeactivationType = {}));
